import { useTranslation } from 'react-i18next';
import { LiliTextArea } from '@lili/lili-frontend-common';
import { CustomRadioButton } from '@Components/inputs/RadioButton/CustomRadioButton';
import { FieldError } from '@Components/inputs/FieldError';
import { ControllerWrapper } from '@Hooks/index';
import { EddEmbeddedFields } from '@Pages/happyFlowPages/eddQuestions/pages/embedded/fields.types';
import { EddYesNo } from '@Pages/happyFlowPages/eddQuestions/consts';

export const CharitiesForm = () => {
  const { t } = useTranslation('eddQuestions');

  return (
    <div className='flex flex-col gap-[16px] mt-[16px]'>
      <ControllerWrapper name={EddEmbeddedFields.EDD_CHARITIES}>
        {({ onChange, value, error }) => {
          const isYesSelected = value === EddYesNo.YES;

          return (
            <>
              <CustomRadioButton
                label={t('organic.charities.no')}
                value={EddYesNo.NO}
                inputId='charities-no'
                onChange={onChange}
                checked={value === EddYesNo.NO}
                name={EddEmbeddedFields.EDD_CHARITIES}
              />
              <CustomRadioButton
                label={t('organic.charities.yes')}
                value={EddYesNo.YES}
                inputId='charities-yes'
                onChange={onChange}
                checked={value === EddYesNo.YES}
                name={EddEmbeddedFields.EDD_CHARITIES}
              />

              {isYesSelected && (
                <div className='flex flex-col gap-2 mt-[-8px]'>
                  <ControllerWrapper name={EddEmbeddedFields.EDD_CHARITIES_DETAILS}>
                    {({
                      onChange: onDetailsChange,
                      value: detailsValue,
                      error: detailsError,
                      onBlur,
                    }) => (
                      <LiliTextArea
                        value={detailsValue}
                        onValueChange={onDetailsChange}
                        errorMsg={detailsError?.message || ''}
                        externalErrorMessage={detailsError?.message || ''}
                        maxLength={100}
                        minLength={10}
                        minHeight='min-h-[88px]'
                        placeholder={t('organic.charities.placeholder')}
                        onBlur={onBlur}
                      />
                    )}
                  </ControllerWrapper>
                </div>
              )}
              <FieldError error={error} testId={`${EddEmbeddedFields.EDD_CHARITIES}-error`} />
            </>
          );
        }}
      </ControllerWrapper>
    </div>
  );
};
